// Re-export RTK Query hooks with original names for backward compatibility
export {
  useGetUserNotificationSettingsQuery as useGetUserNotificationSettings,
  useUpdateUserNotificationSettingsMutation as useUpdateUserNotificationSettings,
  useGetManagedUsersQuery as useGetManagedUsers,
} from 'src/api/redux/users';

// Keep custom wrapper hooks
export { default as useUserImpersonation } from './useUserImpersonation';
export { default as useUserSettings } from './useUserSettings';

export * from './constants';
